import React, { useEffect, useState } from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState(() => {
    // Check for saved end time in sessionStorage
    const saved = sessionStorage.getItem('launch_end');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    // 18 hours, 33 minutes, 9 seconds
    const total = 18 * 3600 + 33 * 60 + 9;
    sessionStorage.setItem('launch_end', String(Date.now() + total * 1000));
    return total;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="bg-gradient-to-b from-[#1a1208] via-[#1f160c] to-[#1a1208] py-16 md:py-24 px-4 text-white" data-id="element-199">
      <div className="max-w-3xl mx-auto text-center" data-id="element-200">
        {/* Heading */}
        <h2 className="font-serif text-2xl md:text-4xl lg:text-[2.6rem] font-bold text-white mb-8 md:mb-10 leading-tight" data-id="element-201">
          ⏰ LAUNCH PRICE ENDS IN:
        </h2>

        {/* Countdown */}
        <div className="flex items-center justify-center gap-3 md:gap-5 mb-3" data-id="element-202">
          <div className="flex flex-col items-center" data-id="element-203">
            <span className="font-serif text-6xl md:text-8xl font-bold text-soft-gold leading-none tracking-tight" data-id="element-204">
              {pad(hours)}
            </span>
            <span className="font-sans text-xs md:text-sm font-bold text-gray-400 uppercase tracking-widest mt-2" data-id="element-205">
              HRS
            </span>
          </div>
          <span className="font-serif text-5xl md:text-7xl font-bold text-soft-gold/60 -mt-4" data-id="element-206">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-207">
            <span className="font-serif text-6xl md:text-8xl font-bold text-soft-gold leading-none tracking-tight" data-id="element-208">
              {pad(minutes)}
            </span>
            <span className="font-sans text-xs md:text-sm font-bold text-gray-400 uppercase tracking-widest mt-2" data-id="element-209">
              MIN
            </span>
          </div>
          <span className="font-serif text-5xl md:text-7xl font-bold text-soft-gold/60 -mt-4" data-id="element-210">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-211">
            <span className="font-serif text-6xl md:text-8xl font-bold text-soft-gold leading-none tracking-tight" data-id="element-212">
              {pad(seconds)}
            </span>
            <span className="font-sans text-xs md:text-sm font-bold text-gray-400 uppercase tracking-widest mt-2" data-id="element-213">
              SEC
            </span>
          </div>
        </div>

        {/* Warning line */}
        <p className="font-sans text-base md:text-lg text-gray-300 mt-8 mb-10 max-w-xl mx-auto leading-relaxed" data-id="element-214">
          <span className="text-yellow-400 font-bold" data-id="element-215">⚠️</span> After that, the
          price goes up by{' '}
          <span className="font-bold text-red-400 line-through" data-id="element-216">NZD $20</span>.{' '}
          This launch price will not stay available.
        </p>

        {/* Spots remaining */}
        <div className="bg-white/5 border border-soft-gold/20 rounded-2xl p-6 md:p-8 max-w-lg mx-auto mb-10" data-id="element-217">
          <div className="flex items-center justify-between mb-3" data-id="element-218">
            <p className="font-sans text-sm md:text-base font-semibold text-red-400 flex items-center gap-2" data-id="element-219">
              <span data-id="element-220">🔴</span> Launch-price spots remaining
            </p>
            <p className="font-sans text-sm md:text-base font-bold text-white" data-id="element-221">
              Only a few left
            </p>
          </div>

          {/* Progress bar */}
          <div className="w-full h-3 bg-white/10 rounded-full overflow-hidden" data-id="element-222">
            <div className="h-full rounded-full bg-gradient-to-r from-orange to-red-500 transition-all duration-1000" style={{
            width: '68%'
          }} data-id="element-223" />
          </div>

          <p className="font-sans text-xs md:text-sm text-gray-400 mt-3 text-right" data-id="element-224">
            68% of the launch-price spots have already been taken
          </p>
        </div>

        {/* CTA */}
        <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-base md:text-xl py-4 md:py-5 px-8 md:px-12 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase" data-id="element-225">
          👉 GET THE MEGAPACK BEFORE THE PRICE GOES UP
        </button>
      </div>
    </section>;
}